enum ItemSlotType {
  Any = 'any',
  Currency = 'currency',
  Disabled = 'disabled',
  Equippable = 'equippable',
}

export default ItemSlotType
